import { scribeHttpV2 } from '@/utils/scribeHTTP';

export async function fetchAllWorkflowsJson(): Promise<unknown> {
  const { data } = await scribeHttpV2.get<unknown>('/rpa/recordings/all-workflows');
  return data;
}

export async function fetchRecordingWorkflowJson(recordingId: string): Promise<unknown> {
  const { data } = await scribeHttpV2.get<unknown>(
    `/rpa/recordings/${encodeURIComponent(recordingId)}`
  );
  return data;
}

export async function deleteRecordingJson(recordingId: string): Promise<unknown> {
  const { data } = await scribeHttpV2.delete<unknown>(
    `/rpa/recordings/${encodeURIComponent(recordingId)}`
  );
  return data;
}
